import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  stats: {
    founders: 3521,
    angels: 10843,
    vcs: 224,
    accelerators: 101,
    matches: 101,
  },
  reports: [
    {
      name: 'Tyler Grayson',
      reason: 'Not a real investor'
    },
    {
      name: 'Tyler Grayson',
      reason: 'Not a real investor'
    },
    {
      name: 'Tyler Grayson',
      reason: 'Not a real investor'
    },
    {
      name: 'Tyler Grayson',
      reason: 'Not a real investor'
    },
    {
      name: 'Tyler Grayson',
      reason: 'Not a real investor'
    },
    {
      name: 'Tyler Grayson',
      reason: 'Fake profile / scam'
    },
    {
      name: 'Tyler Grayson',
      reason: 'Inappropriate messages'
    },
    {
      name: 'Tyler Grayson',
      reason: 'Inappropriate photos'
    },
    {
      name: 'Tyler Grayson',
      reason: 'Inappropriate bio'
    },
    {
      name: 'Tyler Grayson',
      reason: 'Underage user'
    },
    {
      name: 'Tyler Grayson',
      reason: 'Offline behavior'
    },
    {
      name: 'Tyler Grayson',
      reason: 'Not real founder'
    },
  ],
  failedPayments: [
    {
      name: 'Tyler Grayson',
      plan: 'Monthly Plan',
    },
    {
      name: 'Tyler Grayson',
      plan: 'Yearly Plan',
    },
    {
      name: 'Tyler Grayson',
      plan: 'Monthly Plan',
    },
    {
      name: 'Tyler Grayson',
      plan: 'Monthly Plan',
    },
    {
      name: 'Tyler Grayson',
      plan: 'Yearly Plan',
    },
    {
      name: 'Tyler Grayson',
      plan: 'Monthly Plan',
    },
    {
      name: 'Tyler Grayson',
      plan: 'Yearly Plan',
    },
    {
      name: 'Tyler Grayson',
      plan: 'Monthly Plan',
    },
    {
      name: 'Tyler Grayson',
      plan: 'Yearly Plan',
    },
    {
      name: 'Tyler Grayson',
      plan: 'Monthly Plan',
    },
    {
      name: 'Tyler Grayson',
      plan: 'Yearly Plan',
    }
  ],
  recentActivity: [
    {
      name: 'Phoenix Baker',
      description: 'Signed up a new account',
      time: 'Just now',
      type: 'Founder'
    },
    {
      name: 'Lana Steiner',
      description: 'Deleted their account',
      time: 'Just now',
      type: 'Angel'
    },
    {
      name: 'Demi Wikinson',
      description: 'Matched with Lana Steiner',
      time: '2 mins ago',
      type: 'Founder'
    },
    {
      name: 'Lana Steiner',
      description: 'Subscribed to the Monthly Plan',
      time: '3 mins ago',
      type: 'VC'
    },
    {
      name: 'Phoenix Baker',
      description: 'Signed up a new account',
      time: 'Just now',
      type: 'Accelerator'
    },
    {
      name: 'Phoenix Baker',
      description: 'Signed up a new account',
      time: 'Just now',
      type: 'Founder'
    },
  ],
  proofSubmissions: [
    {
      name: 'Tyler Grayson',
      email: 'tylergrayson@gmail.com',
      Proof1: '',
      Proof2: '',
    },
    {
      name: 'Tyler Grayson',
      email: 'tylergrayson@gmail.com',
      Proof1: '',
      Proof2: '',
    },
    {
      name: 'Tyler Grayson',
      email: 'tylergrayson@gmail.com',
      Proof1: '',
      Proof2: '',
    },
    {
      name: 'Tyler Grayson',
      email: 'tylergrayson@gmail.com',
      Proof1: '',
      Proof2: '',
    },
    {
      name: 'Tyler Grayson',
      email: 'tylergrayson@gmail.com',
      Proof1: '',
      Proof2: '',
    },
  ],
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setStats: (state, action) => {
      state.stats = action.payload;
    },
    setReports: (state, action) => {
      state.reports = action.payload;
    },
    setFailedPayments: (state, action) => {
      state.failedPayments = action.payload;
    },
    setRecentActivity: (state, action) => {
      state.recentActivity = action.payload;
    },
    setProofSubmissions: (state, action) => {
      state.proofSubmissions = action.payload;
    },
  },
});

export const {
  setStats,
  setReports,
  setFailedPayments,
  setRecentActivity,
  setProofSubmissions,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
